import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_comp_RowCLass} from '../../dbschema/bl_fi_mst_comp.model';

export class CompanyHeaderContainerModel extends BaseContainerModel {
  bl_fi_mst_comp: bl_fi_mst_comp_RowCLass = new bl_fi_mst_comp_RowCLass();
}
